import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import virtual_components from '@devices/settings/device_settings/virtual_components.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import share from '@devices/settings/device_settings/share.js';
import addon_sensors, { sensor_addon } from '@devices/settings/device_settings/addon_sensors';
import app_setting_output_reader from '@devices/settings/device_settings/app_setting_output_reader';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

const appWithAI = {
	...app_setting_output_reader,
	components: [
		{ title: 'ai_model', component: 'ai_model', test_user: true },
		...app_setting_output_reader.components,
	],
};

export default {
	name: 'ShellyPill',
	friendly_name: 'The Pill',
	family: 'sensor',
	isPM: false,
	addons: sensor_addon,
	//Device-specific addon options
	addons_options: {
		switch: {
			availableViews: ['basic', 'advanced'],
			default_state: 'power_on_default',
		},
		voltmeter: {
			availableViews: ['basic', 'advanced'],
			thrMin: 0.05,
			reportThrMinDecimalDigits: 3,
		},
		measurement_ranges: [
			{
				title: '0-2.5 VDC',
				value: 0,
			},
			{
				title: '0-30 VDC',
				value: 1,
			},
		],
	},
	modes: {
		sensor: {
			availableViews: ['basic', 'advanced'],
			channels: 1,
			notifications: ['offline', 'device_problem', 'forgotten_lights'],
			settings: [
				schedule_gen_2,
				webhooks_gen_2,

				scripts_gen_2,
				virtual_components,
				networks_gen_2_plus,
				bluetooth_gen_2,
				appWithAI,
				share,
				addon_sensors,
				{
					title: 'pill_peripheral_settings',
					components: [
						{
							title: 'pill_peripheral_setup',
							component: 'pill_peripheral_settings',
						},
					],
				},
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode_g2' },
						{ title: 'device_name', component: 'device_name_g2' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'geo_location_and_time_zone', component: 'location_g2' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'factory_reset', component: 'factory_reset' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
